import React, { useEffect, useRef, useState } from "react";
import "./Home.css";

const HomeHero = () => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  const isVideoPlaying = (video) => 
    video && !video.paused && !video.ended && video.readyState > 2;

  useEffect(() => {
    const video = videoRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            if (isVideoPlaying(video)) {
              video.pause();
            }
          } else {
            if (!isVideoPlaying(video)) {
              video.play().catch(() => {}); // ignore autoplay errors
            }
          }
        });
      },
      { threshold: 0.5 }
    );

    if (video) observer.observe(video);

    return () => {
      if (video) observer.unobserve(video);
    };
  }, []);

  const handleUnmute = () => {
    const video = videoRef.current;
    video.muted = false;
    setIsMuted(false);
    video.play().catch(() => {}); // safe call
  };

  return (
    <div className="hero-container">
      <video
        ref={videoRef}
        className="hero-video"
        autoPlay
        loop
        playsInline
        muted={isMuted}
        controls
      
      >
        <source src="/home-hero-vd.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {isMuted && (
        <button className="unmute-btn" onClick={handleUnmute}>
          🔊 Unmute
        </button>
      )}
    </div>
  );
};

export default HomeHero;
